<template>
    <div class="d-flex justify-center fill-height page">
        <v-container class="px-2 pt-0">
            <div class="wrapper d-flex align-start flex-column fill-height mx-auto px-lg-7">

                <v-card flat class="form-wrapper mt-0" :class="{'transparent pt-0': phoneOnly, 'bordered': pcOnly}">
                    <!-- <v-card-title class="pt-0 text-center justify-center mb-1">إنشاء حساب جديد</v-card-title>
                    <v-card-subtitle class="text-center">بإنشائك حساب جديد فأنت توافق على شروط المنصة</v-card-subtitle>
                    <v-divider class="my-2 mx-4" /> -->
                    <div class="d-flex justify-center pa-2 mb-2">
                        <logo height="50" />
                    </div>
                    <v-card-text class="pb-0">
                        
                        <v-form @submit.prevent="register" ref="form">
                            <v-row>
                                <v-col cols="12" class="pb-1 pt-0">
                                    <v-text-field placeholder="أدخل اسمك بالكامل" label="اﻻسم بالكامل" name="name" v-model="name" :disabled="loading" :rules="[rules.global.required, ...rules.fullName]"></v-text-field>
                                </v-col>
                                <v-col cols="12" class="pb-1 pt-0">
                                    <v-text-field class="" placeholder="أدخل البريد الإلكتروني" label="البريد الإلكتروني" name="email" v-model="email" :disabled="loading" :rules="[rules.global.required, ...rules.email]" ></v-text-field>
                                </v-col>
                                <v-col cols="12" class="pb-1 pt-0">
                                    <v-text-field class="" placeholder="أدخل كلمة المرور" label="كلمة المرور"  name="password" v-model="password" :disabled="loading" :rules="[rules.global.required, ...rules.password]" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showPassword ? 'text' : 'password'" @click:append="showPassword = !showPassword"></v-text-field>
                                </v-col>
                                <v-col cols="12" class="pb-1 pt-0">
                                    <v-text-field class="" placeholder="تأكيد كلمة المرور" label="تأكيد كلمة المرور"  name="confirm_password" :disabled="loading" :rules="[rules.global.required, ...rules.confirmPassword]" v-model="confirmPassword" :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showConfirmPassword ? 'text' : 'password'" @click:append="showConfirmPassword = !showConfirmPassword"></v-text-field>
                                </v-col>
                                <v-col cols="12" class="pb-1 pt-0">
                                    <v-select placeholder="اختر نوعك" :label="platform === 'ios' ? 'النوع (اختياري)' : 'النوع'" name="gender" :items="[{text: 'ذكر', value: 'male'}, {text: 'أنثى', value: 'female'}]" v-model="gender" :disabled="loading" :rules="platform !== 'ios' ? [rules.global.required] : undefined" ></v-select>
                                </v-col>
                                <v-col cols="12" class="pb-1 pt-0">
                                    <v-select placeholder="اختر الصف الدراسي" label="الصف الدراسي" name="grade" :items="gradesItems" v-model="grade_id" :disabled="loading" :rules="[rules.global.required]" ></v-select>
                                </v-col>
                                <v-col cols="12" class="pb-1 pt-0">
                                    <v-text-field placeholder="أدخل اسم منطقتك" label="اسم المنطقة" name="region" v-model="region" :disabled="loading" :rules="[rules.global.required]"></v-text-field>
                                </v-col>
                                <v-col cols="12" class="pb-1 pt-0">
                                    <vue-tel-input-vuetify v-model="phone" @validate="phoneValidated" @country-changed="phoneCountryChanged" defaultCountry="EG" class="phone-input" :ignoredCountries="ignoredCountries" placeholder="أدخل رقم الهاتف" label="رقم الهاتف" :rules="[rules.global.required]" :disabled="loading" ></vue-tel-input-vuetify>
                                </v-col>
                                <v-col cols="12" class="pb-1 pt-0">
                                    <vue-tel-input-vuetify v-model="parentPhone" @validate="parentPhoneValidated" @country-changed="parentPhoneCountryChanged" defaultCountry="EG" class="phone-input" :ignoredCountries="ignoredCountries" placeholder="أدخل رقم هاتف ولي اﻷمر" :label="'رقم هاتف ولي اﻷمر' + (platform === 'ios' ? ' (اختياري)' : '')" :rules="platform !== 'ios' ? [rules.global.required] : undefined" :disabled="loading" ></vue-tel-input-vuetify>
                                </v-col>
                                <v-col cols="12" class="pb-1 pt-0">
                                    <v-text-field v-if="appData.force_registration_by_code" placeholder="أدخل كود التسجيل الذي استلمته" label="كود التسجيل"  name="registration_code" :disabled="loading" :rules="[rules.global.required]" v-model="registrationCode" prepend-inner-icon="mdi-account-key"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-btn type="submit" block depressed large :loading="loading" :disabled="loading" color="primary" @click.prevent="register" class="mt-6">إنشاء حساب</v-btn>
                        </v-form>
                        <div class="footer mt-5 text-center">
                            <div class="small-text">
                                باستخدامك للمنصة فأنت توافق على 
                                <v-btn text dense :to="'/privacy-policy'" :disabled="loading" small class="strong-text--text px-0"><span class="small-text">سياسة الخصوصية</span></v-btn>
                            </div>
                            <div>
                                لديك حساب بالفعل؟
                                <v-btn dense text :to="{name: 'login'}" :disabled="loading" class="primary--text px-1">سجل الدخول</v-btn>
                            </div>
                        </div>
                    </v-card-text>
                </v-card>
            </div>
        </v-container>
        <slot name="footer" />
    </div>
</template>
<script>

// @ is an alias to /src
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

import AppAPI from '@/app-api'

export default {
    name: 'register',
    data(){
        return {
            registrationCode: '',
            
            name: '',
            email: '',
            password: '',
            showPassword: false,
            confirmPassword: '',
            showConfirmPassword: false,
            gender: '',
            grade_id: '',
            region: '',

            deviceToken: null,

            phone: '',
            fullPhone: '',
            phoneValid: true,
            phoneCountry: '',

            parentPhone: '',
            parentFullPhone: '',
            parentPhoneValid: true,
            parentPhoneCountry: '',

            ignoredCountries: ['IL'],  // will be deleted from select country of phone number input

            loading: false,

            rules: {
                global: {
                    required: value => !!value || 'لا يمكنك ترك الحقل فارغاً'
                },
                email: [
                    value => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        return pattern.test(value) || 'البريد الإلكتروني غير صحيح';
                    }
                ],
                password: [
                    value => value.length >= 6 || "يجب أن لا يقل عدد الحروف عن 6"
                ],
                confirmPassword: [
                    value => value === this.password || 'كلمتا المرور غير متطابقتين'
                ],
                fullName: [
                    value=>{
                        const valid = value.trim().split(' ').length > 2 && value.length >= 10;
                        return valid || 'يجب إدخال الاسم ثلاثي أو رباعي'
                    }
                ]
            }
        };
    },
    components: {},
    computed:{
        gradesItems(){
            return this.appData ? this.appData.grades.map(grade=>{
                return {text: grade.name, value: grade.id};
            }) : [];
        },
        ...GlobalComputed,
    },
    methods: {
        phoneCountryChanged(country){
            this.phoneCountry = country;
        },
        phoneValidated(data){
            this.phoneValid = data.isValid;
            this.fullPhone = data.number;
            if (data.country){
                this.phoneCountry = data.country;
            }
        },
        parentPhoneCountryChanged(country){
            this.parentPhoneCountry = country;
        },
        parentPhoneValidated(data){
            this.parentPhoneValid = data.isValid;
            this.parentFullPhone = data.number;
            if (data.country){
                this.parentPhoneCountry = data.country;
            }
        },
        async register(){

            if (this.formValidate()){
                let data = {
                        name: this.name,
                        email: this.email,
                        password: this.password,
                        gender: this.gender,
                        grade_id: this.grade_id,
                        region: this.region,

                        phone: this.phone.replaceAll(' ', ''),
                        full_phone: this.fullPhone,
                        phone_country: this.phoneCountry,

                        parent_phone: this.parentPhone,
                        parent_full_phone: this.parentFullPhone,
                        parent_phone_country: this.parentPhoneCountry,
                    };
                    if (this.appData.force_registration_by_code){
                        data.registration_code = this.registrationCode;
                    }
                
                    if (!this.deviceToken && this.capRunning && this.isProduction){
                        await this.getFcmToken();
                    }
                    
                    if (this.deviceToken){
                        data.deviceToken = this.deviceToken;
                    }
                    
                    this.registerAction(data);
            }
        },
        registerAction(data){
            this.loading = true;

            this.$store.dispatch('registerAction', data).then((resolveData)=>{
                this.loading = false;
                if (resolveData.message){
                    this.showMsg(resolveData.message, 'success');
                }
                if (resolveData.redirect && resolveData.redirect === 'confirm'){
                    this.$router.push({name: 'confirm'});
                }else if (resolveData.redirect === 'login'){
                    this.$router.push({name: 'login'});
                }else{
                    this.$router.push({name: 'home'});
                }
            }).catch(error=>{
                this.loading = false;
                if (error.response && error.response.status === 422){
                    // coming errors from backend
                    let errors = error.response.data.errors;
                    this.showMsg(errors[Object.keys(errors)[0]][0]);
                }else{
                    this.showMsg('حدثت مشكلة أثناء إنشاء الحساب');
                }
            })
        },
        
        showMsg(text, color = 'error', timeout = 4000){
            this.$store.dispatch('addSnackMsg', {show: true, text: text, color: color, timeout: timeout});
        },
        formValidate(){
            if (this.$refs.form.validate()){
                if (this.phoneValid){
                    // it's optional in ios
                    if (this.parentPhoneValid || this.platform === 'ios'){
                        return true;
                    }else{
                        this.showMsg('أدخل رقم هاتف ولي اﻷمر بشكل صحيح');
                    }
                }else{
                    this.showMsg('أدخل رقم الهاتف بشكل صحيح');
                }
            }else{
                this.showMsg('البيانات التي أدخلتها غير صحيحة');
            }
            return false;
        },

        getFcmToken(){
            const self = this;
            return AppAPI.Notifications.getDeviceToken(
                response=>{
                    const deviceToken = response.token;
                    self.deviceToken = deviceToken;
                },
                error=>{
                    if (this.capRunning && this.isProduction){
                        window.console.error(error);
                    }
                },
            );
        },
        
        ...GlobalMethods,
        
    },
    watch: {
        
    },
    mounted(){
        if (this.capRunning && this.isProduction){
            this.getFcmToken();
        }
    }
}
</script>

<style lang="scss" scoped>
    .logo-wrapper{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 30vh;

        .logo{
            height: auto;
            margin: 1rem 0;
            
            max-width: 150px;
            min-width: 120px;
        }
        &.sm{
            height: auto;
            transition: 0.5s ease all;
            .logo{
                max-width: 125px;
                min-width: 110px;
            }
        }
    }
    .form-wrapper{
        @media(min-width: 960px){
            width: 600px;
            margin-top: 2rem;
        }
    }

</style>
<style lang="scss">

    .phone-input {
        input::placeholder{
            direction: rtl!important;
            text-align: right!important;
        }
        input, .v-text-field__details{

            direction: ltr!important;
            text-align: left;
        }
        // .v-text-field__details{
        //     direction: rtl!important;
        //     text-align: right!important;
        // }
    }
</style>